import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "../home.css";
import img1 from "../Image/enroll1.jpg";
import img2 from "../Image/elev.jpg";
import img3 from "../Image/emp1.jpg";

function Work() {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const rotate1 = useTransform(scrollYProgress, [0, 1], [-35, -6]);
  const y1 = useTransform(scrollYProgress, [0, 1], [120, 0]);
  const z1 = useTransform(scrollYProgress, [0, 1], [-150, 0]);
  const rotate2 = useTransform(scrollYProgress, [0, 1], [35, 6]);
  const y2 = useTransform(scrollYProgress, [0, 1], [150, 0]);
  const z2 = useTransform(scrollYProgress, [0, 1], [-150, 0]);

  const rotate3 = useTransform(scrollYProgress, [0, 1], [8, 0]);
  const y3 = useTransform(scrollYProgress, [0, 1], [200, 20]);
  const z3 = useTransform(scrollYProgress, [0, 1], [-80, 0]);

  const opacity = useTransform(scrollYProgress, [0, 0.15], [0, 1]);

  return (
    <div className="work-main-wrapper hide-mobile">
      <div className="work-text">
        <h1 className="work-big-title">
          How ACADME <br /> Works <br /> Your journey to success <br /> in three
          simple steps
        </h1>
      </div>

      <div className="work-cards-area" ref={ref}>
        <motion.img
          src={img1}
          className="work-card-img card-1"
          style={{
            rotateY: rotate1,
            y: y1,
            opacity,
            z: z1,
          }}
        />

        <motion.img
          src={img2}
          className="work-card-img card-2"
          style={{
            rotateY: rotate2,
            y: y2,
            opacity,
            z: z2,
          }}
        />

        <motion.img
          src={img3}
          className="work-card-img card-3"
          style={{
            rotateY: rotate3,
            y: y3,
            opacity,
            z: z3,
          }}
        />
      </div>
    </div>
  );
}

export default Work;
